import { AxiosResponse } from 'axios'
import { IFilter } from 'types/common'
import { api } from 'API'
import { IGroupProcess } from 'interfaces/process'

const BASE = '/groups-processes'

export async function shareProcessToGroups(groupIds: number[], processId: number): Promise<void> {
  const response: AxiosResponse = await api.post(`${BASE}/share-to-groups`, { groupIds, processId })
  return response.data
}

export async function shareProcessesToGroups(groupIds: number[], processIds: number[]): Promise<void> {
  const response: AxiosResponse = await api.post(`${BASE}/share-to-groups/batch`, { groupIds, processIds })
  return response.data
}

export async function getGroupsProcesses(filter: IFilter<IGroupProcess>): Promise<IGroupProcess[]> {
  const response: AxiosResponse = await api.get(`${BASE}?filter=${JSON.stringify(filter)}`)
  return response?.data ?? []
}
